'use client';
import React from 'react';

const LitGlobalStyles: React.FC = () => (
  <style jsx global>{`
    :root {
      --background-color: #0b0b0b;
      --text-color: #f0f0f0;
      --neon-cyan: #00ffff;
      --neon-violet: #8A2BE2;
      --card-bg: #1a1a1a;
      --hero-zoom: 1.32;
      --hero-zoom-ready: 1.36;
      --nav-h: 105px;
    }

    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      background: var(--background-color);
      color: var(--text-color);
      overflow-x: hidden;
      scroll-behavior: smooth;
      font-family: Arial, sans-serif;
    }
    body.menu-open { overflow: hidden; }
    main.landing {
      width: 100%;
      overflow-x: clip;
    }

    /* Only apply big section padding on landing pages, not globally */
    main.landing > section {
      padding: 100px 10%;
      border-bottom: 1px solid #222;
    }

    body.loading main.landing > :not(.hero) { visibility: hidden !important; opacity: 0 !important; }
    body.loading main.landing .hero { visibility: visible !important; opacity: 1 !important; }
    body.loading .vision-engine-page { visibility: visible !important; opacity: 1 !important; }

    .cta-button {
      display: inline-block;
      margin-top: 28px;
      padding: 15px 35px;
      border: 1px solid var(--neon-cyan);
      border-radius: 50px;
      background: transparent;
      color: var(--text-color);
      font-size: 1rem;
      font-weight: 600;
      text-decoration: none;
      cursor: pointer;
      box-shadow: 0 0 5px var(--neon-cyan), 0 0 15px var(--neon-cyan);
      transition: background-color .3s ease, color .3s ease, box-shadow .3s ease, transform .2s ease;
    }
    .cta-button:hover {
      background: var(--neon-cyan);
      color: #000;
      box-shadow: 0 0 10px var(--neon-cyan), 0 0 25px var(--neon-cyan), 0 0 50px var(--neon-cyan);
      transform: translateY(-2px);
    }

    h2 { font-size: 2.5rem; margin-bottom: 40px; text-align: center; }
    p { font-size: 1.1rem; line-height: 1.7; font-weight: 300; }

    footer { padding: 40px 10%; text-align: center; color: #888; }

    @media (max-width: 768px) {
      main.landing > section {
        padding: 72px 1rem;
      }

      footer {
        padding: 32px 1rem;
      }
    }
  `}</style>
);

export default LitGlobalStyles;
